import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import './QAStyledTableBody.css';
import HighlightKeywordCell from  '../../FunctionArea/HighlightKeywordCell'

const useStyles = makeStyles({
    StyledBody: {
    },
    StyledRow: {
        cursor:"pointer"
    },
    StyledCell:{
        color:"black",
        fontFamily:"Microsoft JhengHei",
        fontSize:12
    },
    mountBottom:{
        width:"50px",
        backgroundColor:"#a7fafa",
        color:"black",
        border:"1px solid",
        borderRadius:"5px",
        textAlign:"center",
        cursor:"pointer",
        '&:hover':{
            backgroundColor:"#c9ffff",
        },
    },
    unmountBottom:{
        width:"50px",
        backgroundColor:"#a2b8b8",
        color:"black",
        border:"1px solid",
        borderRadius:"5px",
        textAlign:"center",
        cursor:"pointer",
        '&:hover':{
            backgroundColor:"#c9ffff",
        },
    },

  });

function CellGroup(props) {
    const classes = useStyles();
  
    let result
    if(props.status)
    {
        let temp = []
        props.status.forEach(element => {
            if(element.status)
            {
                temp.push(element)
            }
        });

        result = temp.map((column,index)=>{
            return  <TableCell className={classes.StyledCell} key={index} align="left"><HighlightKeywordCell text={String(transKeyword(props.row[column.columnName]))} keywords={props.keywords}/></TableCell>
        })
    }
    else
    {
        result = null
    }

    return result
}

function transKeyword(keyword) {
    switch(keyword){
        case "cmsStage1A":
            return "您好，歡迎使用藏品資料查詢系統"
        case "cmsStage1B":
            return "請問您是要：1.我有使用上的問題想請教。 2.我發現資料文字有錯誤! 3.我發現系統有些功能不正常! 4.我對於此系統有些建議跟想法。 5.都不是，我有其他問題..."
        case "cmsStage2":
            return "好的，接下來請讓我們知道如何稱呼您，請於下方輸入您的名稱~"
        case "cmsStage3":
            return "謝謝您! 為方便聯繫您，再請您輸入您的email帳號。"
        case "cmsStage4A":
            return "謝謝您，接下來請描述您的問題或意見。"
        case "cmsStage4B":
            return "1. 截圖功能：您可以點擊按鈕，頁面左上會出現可拖曳放大之截圖框。將其拖曳至您有問題之區域，再點擊截圖框左上同樣圖示，即可截圖並傳送給系統客服，使客服更直覺地了解您的問題。"
        case "cmsStage4C":
            return "2. 文字數量：如您的意見文字較多，可分段輸入，請勿一對話框超過180字，如已陳述完畢，請於獨立對話框輸入'完畢'或'Done'，系統始進入下一階段。"
        case "cmsStage5A":
            return "謝謝您提供的意見，如系統客服人員在線的話，將直接線上回覆您，若不在線，將於2日內回覆至您的信箱。"
        case "cmsStage5B":
            return "如您有新的問題，請於下方輸入:'我有問題'。"
        case "cmsQueryType1":
            return "使用問題"
        case "cmsQueryType2":
            return "文字勘誤"
        case "cmsQueryType3":
            return "系統Bug"
        case "cmsQueryType4":
            return "建議想法。"
        case "cmsQueryType5":
            return "其他問題。"
        case null:
            return ""
        default :
            return keyword
    }

}


const QAStyledTableBody =(props)=> {
    const classes = useStyles();
    //let index = 1

    //const handlerClick =(msg)=>{
    //    props.toggleMovieMount(msg)
    //}

    const getIndex=(index)=>{
        if(props.limitNumber && props.pageNumber)
        {
            let output = props.limitNumber * (props.pageNumber-1) + 1 + index
            return output
        } 
        else
        {
            return 0
        }
    }

    return (
        <TableBody className={classes.StyledBody}>
            {
                props.listData.map((row,index)=>(
                    <TableRow hover className={classes.StyledRow} key={row.ID} onClick={()=>props.handleRecordListClicked(row.ID)}>
                        <TableCell className={classes.StyledCell} align="left">{getIndex(index)}</TableCell>                       
                        <CellGroup row={row} status={props.columnStatus} keywords={props.keywords}/>                    
                    </TableRow>
                ))
            }
        </TableBody>
    )
}

export default QAStyledTableBody